import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { normalizeLocale } from '../services/contentService'

// 导入语言包
import zh from './zh.json'
import zhHant from './zh-hant.json'
import en from './en.json'

Vue.use(VueI18n)

// 从localStorage获取当前语言设置
const getCurrentLocale = () => {
  const stored = localStorage.getItem('locale') || 'zh'
  const normalized = normalizeLocale(stored)

  if (stored !== normalized) {
    localStorage.setItem('locale', normalized)
  }
  return normalized // 默认中文
}

const i18n = new VueI18n({
  locale: getCurrentLocale(), // 默认语言
  fallbackLocale: 'zh', // 回退语言
  messages: {
    zh,
    'zh-Hant': zhHant,
    en
  }
})

// 监听语言变化
window.addEventListener('localeChange', (event) => {
  const newLocale = normalizeLocale(event?.detail?.locale || 'zh')
  localStorage.setItem('locale', newLocale)
  i18n.locale = newLocale
  console.log('Vue i18n locale changed to:', newLocale)
})

export default i18n
